import { ref, computed } from 'vue'

export function useProjectsStore(api) {
  const projects = ref([])
  const loading = ref(false)
  const currentProjectId = ref(null)

  const currentProject = computed(() =>
    projects.value.find(p => p.id === currentProjectId.value) || null
  )

  async function fetchProjects() {
    loading.value = true
    try {
      const data = await api.get('/api/projects')
      projects.value = data.projects
    } finally {
      loading.value = false
    }
  }

  async function createProject(attrs) {
    const data = await api.post('/api/projects', { project: attrs })
    projects.value.push(data.project)
    return data.project
  }

  async function updateProject(id, attrs) {
    const data = await api.patch(`/api/projects/${id}`, { project: attrs })
    const idx = projects.value.findIndex(p => p.id === id)
    if (idx !== -1) projects.value[idx] = data.project
    return data.project
  }

  async function deleteProject(id) {
    await api.delete(`/api/projects/${id}`)
    projects.value = projects.value.filter(p => p.id !== id)
    if (currentProjectId.value === id) currentProjectId.value = null
  }

  function selectProject(id) {
    currentProjectId.value = currentProjectId.value === id ? null : id
  }

  return {
    projects,
    loading,
    currentProjectId,
    currentProject,
    fetchProjects,
    createProject,
    updateProject,
    deleteProject,
    selectProject,
  }
}
